let elements = {
  //pick: 3,
  blockCheck: true,
  // permanent: true,
  disableAfterEnd: true,

  mainImage: {
    imagePath: 'games/page043_game11/img/bcg2.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page043_game11/audio/false.mp3',
    // positive: 'games/page043_game11/audio/true.mp3',
    click: 'games/page043_game11/audio/click.mp3',
    icon: {
      on: 'games/page043_game11/img/audioOn.png',
      off: 'games/page043_game11/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 20,
    height: 20,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 218,
    height: 214,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 434,
        y: 130,
      },
    },
    {
      pos: {
        x: 914,
        y: 130,
      },
    },
    {
      pos: {
        x: 1392,
        y: 130,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: true,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page043_game11/audio/62_shake.mp3',
          correct: {
            image: {
              src: 'games/page043_game11/img/2.png',
            },
            width: 430,
            height: 630,
            correctItems: {
              images: [
                {
                  src: 'games/page043_game11/img/2g.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 430,
                  height: 630,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page043_game11/img/1.png',
            },
            width: 430,
            height: 630,
            incorrectItems: {
              images: [
                {
                  src: 'games/page043_game11/img/1r.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 430,
                  height: 630,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page043_game11/img/3.png',
            },
            width: 430,
            height: 630,
            incorrectItems: {
              images: [
                {
                  src: 'games/page043_game11/img/3r.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 430,
                  height: 630,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page043_game11/audio/62_shake.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page043_game11/img/audioOn.png', iconOff: 'games/page043_game11/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 50,
        x: 160,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
